import React from 'react';
import OverviewRanking from './OverviewRanking';
import AlarmTierCard from './AlarmTierCard';

/**
 * Renderiza el bloque DashboardOverview de SCAPP V2.
 *
 * @param {object} props
 * @param {object} props.v - Modelo de presentación y callbacks del panel.
 * @returns {React.ReactNode} Bloque visual sin estado local.
 */
export default function DashboardOverview({
  v
}) {
  return React.createElement("div", {
    style: {
      "display": v.leftDisp,
      "flexDirection": "column",
      "gap": "1.111111vh",
      "minHeight": "0",
      "gridColumn": v.overviewCol,
      "gridRow": v.overviewRow
    }
  }, v.text("\n      "), React.createElement(OverviewRanking, {
    v
  }), v.text("\n\n      "), React.createElement(AlarmTierCard, {
    v
  }), v.text("\n\n      "), v.alEmpty ? null : React.createElement("section", {
    style: {
      "background": "linear-gradient(180deg,rgba(22,40,64,0.55) 0%,rgba(12,24,42,0.55) 100%)",
      "border": "0.092593vh solid rgba(46,179,238,0.14)",
      "borderRadius": "0.925926vh",
      "boxShadow": "0 0.092593vh 0 rgba(255,255,255,0.03) inset,0 0.740741vh 2.222222vh rgba(0,0,0,0.25)",
      "backdropFilter": "blur(0.555556vh)",
      "padding": "1.111111vh 1.296296vh",
      "display": "flex",
      "flexDirection": "column",
      "gap": "0.555556vh",
      "flex": "1",
      "minHeight": "0"
    }
  }, v.text("\n        "), React.createElement("div", {
    style: {
      "display": "flex",
      "justifyContent": "space-between",
      "alignItems": "baseline"
    }
  }, React.createElement("h2", {
    style: {
      "margin": "0",
      "fontSize": "1.296296vh",
      "fontWeight": "600"
    }
  }, v.text("Alarmas del día · " + v.selName))), v.text("\n        "), React.createElement("div", {
    style: {
      "display": "grid",
      "gridTemplateColumns": "0.625vw 3.75vw minmax(0,1fr) 5vw",
      "gap": "0.925926vh",
      "padding": "0.185185vh 0.555556vh",
      "fontSize": "0.925926vh",
      "color": "#8793a6",
      "textTransform": "uppercase",
      "letterSpacing": "0.05em",
      "borderBottom": "0.092593vh solid rgba(46,179,238,0.12)"
    }
  }, React.createElement("span", {}, null), React.createElement("span", {}, v.text("Inicio")), React.createElement("span", {}, v.text("Duración")), React.createElement("span", {
    style: {
      "textAlign": "right"
    }
  }, v.text("Reacción"))), v.text("\n        "), React.createElement("div", {
    style: {
      "flex": "1",
      "minHeight": "0",
      "overflow": "auto",
      "display": "flex",
      "flexDirection": "column",
      "gap": "0.092593vh"
    }
  }, v.text("\n          "), (v.alList || []).map((a, index13) => React.createElement(React.Fragment, {
    key: index13
  }, v.text("\n            "), React.createElement("div", {
    "onClick": a.onClick,
    "onMouseEnter": a.enter,
    "onMouseLeave": a.leave,
    style: {
      "display": "grid",
      "gridTemplateColumns": "0.625vw 3.75vw minmax(0,1fr) 5vw",
      "gap": "0.925926vh",
      "alignItems": "center",
      "padding": "0.462963vh 0.555556vh",
      "borderRadius": "0.37037vh",
      "cursor": "zoom-in",
      "background": a.bg
    },
    className: "scapp-full-hover"
  }, v.text("\n              "), React.createElement("span", {
    style: {
      "width": "0.46875vw",
      "height": "0.833333vh",
      "borderRadius": "50%",
      "background": a.fill,
      "border": "0.185185vh solid " + a.c
    }
  }, null), v.text("\n              "), React.createElement("span", {
    style: {
      "font": "1.111111vh 'IBM Plex Mono',monospace"
    }
  }, v.text(a.time)), v.text("\n              "), React.createElement("span", {
    style: {
      "font": "1.111111vh 'IBM Plex Mono',monospace",
      "color": "#b8c1ce"
    }
  }, v.text(a.dur)), v.text("\n              "), React.createElement("span", {
    style: {
      "font": "1.111111vh 'IBM Plex Mono',monospace",
      "textAlign": "right",
      "color": a.c
    }
  }, v.text(a.react)), v.text("\n            ")), v.text("\n          "))), v.text("\n        ")), v.text("\n      ")), v.text("\n    "));
}
